import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@reducers/index';
import { fetchTeamInfoList } from '@reducers/account/thunks/teamThunk';
import { setOpenPopup } from '@reducers/account/teamSlice';
import { ITeamCreateObj } from '@models/manager/account/accountModel';
import { axiosDummyReqTypeInstance } from '@utils/axios/axiosInstance';

const CreateTeamPopup = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [reqParams, setReqParams] = useState<ITeamCreateObj>({
    teamName: '',
    description: '',
  });

  const onChangeHandler = useCallback((event) => {
    const { name, value } = event.target;
    if (name === 'team') {
      setReqParams((prev) => ({ ...prev, teamName: value }));
    } else if (name === 'description') {
      setReqParams((prev) => ({ ...prev, description: value }));
    }
  }, []);

  const onClosePopupHandler = useCallback(() => {
    dispatch(setOpenPopup({ isOpen: false }));
  }, [dispatch]);

  const onClickCreateNewTeam = useCallback(async () => {
    if (reqParams.teamName.trim().length === 0) {
      return alert('Please enter your team name');
    }
    if (confirm('Do you want to create a team?')) {
      // TODO: 아래부분 수정처리
      const { status, data, statusText } = await axiosDummyReqTypeInstance<ITeamCreateObj>(reqParams).get(
        '/api/commonGetResponse.json'
      );
      if (status === 200) {
        await dispatch(fetchTeamInfoList({ userId: 'ss' }));
        await alert('Team Create Complete');
        dispatch(setOpenPopup({ isOpen: false }));
      } else {
        alert(`${statusText} error occured`);
      }
    }
  }, [reqParams, dispatch, axiosDummyReqTypeInstance, fetchTeamInfoList, setOpenPopup]);

  return (
    <div className="lpopup-wrap">
      <div className="lpopup-content lpopup-lsmallsize">
        <h2 className="lpopup-tit">Create A New Team</h2>
        <div className="lpopup-container">
          <div className="lpopup-tbl-inner">
            <table className="lpopup-tbl-2">
              <colgroup>
                <col width="25%" />
                <col width="" />
              </colgroup>
              <tbody>
                <tr>
                  <th className="left">Team Name</th>
                  <td>
                    <label className="ipt type-gray">
                      <input type="text" name="team" value={reqParams.teamName} onChange={onChangeHandler} />
                    </label>
                  </td>
                </tr>
                <tr>
                  <th className="left">Description</th>
                  <td>
                    <textarea
                      className="textarea"
                      name="description"
                      value={reqParams.description}
                      onChange={onChangeHandler}
                    ></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="lpopup-btn">
            <button
              type="button"
              disabled={
                reqParams.description.trim().length === 0 || reqParams.teamName.trim().length === 0 ? true : false
              }
              className="btn pri"
              onClick={onClickCreateNewTeam}
            >
              Create New Team
            </button>
            <button type="button" className="btn sec" onClick={onClosePopupHandler}>
              Cancel
            </button>
          </div>
        </div>
        <button type="button" className="lpopup-close" onClick={onClosePopupHandler}>
          <span className="blind">닫기</span>
        </button>
      </div>
    </div>
  );
};

export default CreateTeamPopup;
